import React, { useState } from 'react'
import { Link } from 'gatsby'

const Navigation = props => {
  const [showMenu, setShowMenu] = useState(false)
  const toggleMenu = () => setShowMenu(!showMenu)

  return (
    <div id='nav'>
        <div id='header'>
          <Link to={'/'}>
            <h1 id='sofia'>SOFIA</h1>
            <h1 id='vidal'>VIDAL</h1>
          </Link>
          <div id='menu' onClick={toggleMenu}>
            <div/>
            <div/>
            <div/>
          </div>
        </div>
        

      <div id='collections'>
        {
          props.allStrapiCollection.edges.map(({node}) =>
            <Link to={`/collection/${node.name}`} className='nav-link'>
              <p>
              { node.name }
              </p>
            </Link>
          )
        }
      </div>
      
      <div id='collections'>
        <Link to='/about' className='nav-link'>
          <p>
            ABOUT
          </p>
        </Link>
      </div>

      <div id='collections-mobile' style={ showMenu ? {} : { display: 'none' }}>
        {
          props.allStrapiCollection.edges.map(({node}) =>
            <Link to={`/collection/${node.name}`} className='nav-link'>
              <p>
              { node.name }
              </p>
            </Link>
          )
        }
         <Link to='about' className='nav-link'>
          <p>
            ABOUT
          </p>
        </Link>
      </div>


    </div>
  )
}

export default Navigation